// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_13f76e2f","breadcrumbItem":"_f1098912"};